import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";

import { Accordion } from "../Accordion";
import AccordionChild from "../Accordion/AccordionChild";
import { getMiniLeaguesData } from "./miniLeaguesData";
import MiniLeagueBody from "../MiniLeagueBody";
import MiniLeagueHeadLHS from "../MiniLeagueHeadLHS";

const PrizeWrap = ({ prizePara }) => {
  const [miniLeagues, setMiniLeagues] = useState([]);
  const [activeIndex, setActiveIndex] = useState(miniLeagues?.[0]?.isActive);
  const [isUpdateAccordion, setIsUpdateAccordion] = useState(false);
  const masterConfigState = useSelector((state) => state.masterConfig);
  const prizesMasterConfigData = masterConfigState?.data?.Prizes?.web;

  useEffect(() => {
    if (masterConfigState?.success && prizesMasterConfigData) {
      const updatedMiniLeaguesData = getMiniLeaguesData(prizesMasterConfigData);
      setMiniLeagues(updatedMiniLeaguesData);
    }
  }, [masterConfigState?.success, prizesMasterConfigData]);

  const updateMiniLeagues = (data) => setMiniLeagues(data);

  const updateActiveIndex = (index, value) => {
    if (!value) {
      setActiveIndex(-1);
    } else {
      setActiveIndex(index);
    }
    setIsUpdateAccordion(true);
  };

  return (
      <Accordion
        data={miniLeagues}
        activeIndex={activeIndex}
        isUpdateAccordion={isUpdateAccordion}
        updateData={updateMiniLeagues}
        accordionChild={miniLeagues?.map((miniLeague, index) => {
          return (
            <AccordionChild
              key={index}
              accordionConfig={{ showAccordRHS: false }}
              headComponentLHS={<MiniLeagueHeadLHS miniLeague={miniLeague} />}
              bodyComponent={
                <MiniLeagueBody
                  miniLeague={miniLeague}
                  showViewMiniLeagues={true}
                />
              }
              isActive={miniLeague?.isActive}
              index={index}
              updateActiveIndex={updateActiveIndex}
            />
          );
        })}
      />
  );
};

export { PrizeWrap };
